export const GA_MEASUREMENT_ID = 'G-XTCNXE31S2';
export const GTM_CONTAINER_ID = 'GTM-KS6ZL7J2';
export const CLARITY_PROJECT_ID = 'wrcqxkeoow';

/** Delay (ms) before loading analytics if the visitor never interacts with the page. */
export const IDLE_TIMEOUT_MS = 5000;

/** First interaction with any of these events triggers the analytics load. */
export const INTERACTION_EVENTS = ['scroll', 'click', 'touchstart', 'keydown'];
